import React, { useState, useEffect } from 'react';
import AwardsModal from 'components/AwardsModal';
import { AWARDS } from 'utils/awardsConfig';


import Avatar from 'components/Avatar';
import Sidebar from 'components/Sidebar';

import SkillChart from 'components/SkillChart';

import Award from 'assets/images/profile/award.png'; // Example award image, adjust as needed

import { useUser, useDailyProgress, useUserStatsHistory } from 'utils/userContext';

import { Link } from 'react-router-dom';
import ROUTES from "utils/routes.js";

function Arrow({ className }) {
    return <svg className={className} width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M8.64216 7.77766L1.72819 14L0 12.4447L6.04988 7L0 1.55531L1.72819 0L8.64216 6.22234C8.87128 6.42861 9 6.70834 9 7C9 7.29166 8.87128 7.57139 8.64216 7.77766Z" fill="#3C3E4E" />
    </svg>
}

function SkillArrow({ w, h, colorStart = '#ffffff', colorEnd = '#000000', id = '1' }) {
    const gradientId = `skillArrowGradient-${id}`;

    return (
        <svg width={w || "20"} height={h || "11"} viewBox="0 3.5 20 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="11" gradientUnits="userSpaceOnUse">
                    <stop offset="0%" stopColor={colorStart} />
                    <stop offset="100%" stopColor={colorEnd} />
                </linearGradient>
            </defs>
            <path
                d="M8.81622 0.464059L0.489749 8.3082C0.334479 8.45448 0.211313 8.62813 0.127282 8.81925C0.0432508 9.01037 -7.80157e-08 9.21521 -6.89734e-08 9.42207C-5.07115e-08 9.83986 0.176168 10.2405 0.489749 10.5359C0.645019 10.6822 0.829351 10.7983 1.03222 10.8774C1.23509 10.9566 1.45252 10.9973 1.67211 10.9973C2.11558 10.9973 2.54089 10.8314 2.85447 10.5359L9.99858 3.78998L17.1427 10.5359C17.2975 10.683 17.4817 10.7997 17.6846 10.8793C17.8875 10.959 18.1052 11 18.325 11C18.5449 11 18.7626 10.959 18.9655 10.8793C19.1684 10.7997 19.3526 10.683 19.5074 10.5359C19.6635 10.3901 19.7874 10.2166 19.8719 10.0254C19.9565 9.83423 20 9.62918 20 9.42207C20 9.21497 19.9565 9.00991 19.8719 8.81874C19.7874 8.62756 19.6635 8.45405 19.5074 8.3082L11.1809 0.464059C11.0261 0.317015 10.8419 0.200299 10.639 0.120652C10.4361 0.0410047 10.2184 5.07013e-07 9.99858 5.16623e-07C9.77874 5.26232e-07 9.56108 0.0410047 9.35814 0.120652C9.15521 0.200299 8.97103 0.317015 8.81622 0.464059Z"
                fill={`url(#${gradientId})`}
            />
        </svg>
    );
}

function Summary() {
    const [showAwardsModal, setShowAwardsModal] = useState(false);
    const { user, loading, triggerAwardCheck } = useUser();
    const { minutesComplete, lessonsComplete, loading: progressLoading } = useDailyProgress();
    const { statsHistory, loading: statsLoading } = useUserStatsHistory();

    useEffect(() => {
        if (user?.id) {
            triggerAwardCheck(user.id);
        }
    }, [user?.id]);

    return (
        <div className="flex flex-row items-center h-screen gap-4 bg-background p-4 lg:p-8" >
            <Sidebar></Sidebar>
            <div className='w-full flex flex-col items-center h-full px-2 lg:px-0 xl:px-12 overflow-y-auto gap-4 flex-shrink pb-10'>
                <div className="select-none flex justify-between items-center  w-full max-w-[900px]">
                    <div className="h-[3.7rem] flex flex-col">
                        <h1 className="text-text-light text-sm md:text-base drop-shadow-lg max-w-2xl ">
                            {new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}
                        </h1>
                        <h1 className=" text-text text-3xl md:text-[2.25rem] leading-[1] font-bold drop-shadow-lg max-w-2xl ">
                            Summary
                        </h1>
                    </div>
                    {!user?.isGuest && <Avatar size={"xs"} showRings={false} dropdown={true} />}
                </div>

                {user?.isGuest ? (
                    <div className='w-full max-w-[900px]'>
                        <div className='flex flex-col w-full bg-background-pop h-full rounded-3xl p-8 items-center text-xl gap-8 text-center'>
                            <span>You are in guest mode. Please make an account to save your progress, customize your experience, and access more features.</span>
                            <Link to={ROUTES.SIGNUP} className="bg-background-light text-white font-bold px-4 py-2 rounded-2xl shadow-md hover:bg-background transition-all duration-500 text-lg border-2 border-primary">CREATE AN ACCOUNT</Link>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className='min-h-fit flex flex-col lg:flex-row gap-4 w-full max-w-[900px] xl:h-64'>
                            <div className='lg:basis-2/3 grow w-full bg-background-pop h-fit lg:h-full rounded-3xl lg:min-h-[16rem]'>
                                <div className='text-xl pr-5 pl-7 py-3 font-medium text-text h-fit border-b-[3px] border-border flex items-center justify-between'>
                                    <h2 >Today's Coding Progress</h2>
                                    {/* <Arrow className='mt-2 h-4 w-4' /> */}
                                </div>
                                <div className='px-5 xl:px-8 py-4 lg:py-5 mb-1 flex flex-row gap-4 sm:gap-8 xl:gap-12 items-center justify-center lg:justify-start'>
                                    <Avatar size={"lg"} summaryAvatar={true} dropdown={false}></Avatar>
                                    <div className='flex flex-col gap-2 sm:gap-5'>
                                        <div className='flex flex-col '>
                                            <span className='text-text text-lg lg:text-xl font-bold'>Time Goal</span>
                                            <span className='text-primary text-base lg:text-lg font-medium'>{Math.floor(minutesComplete || 0)}/{!loading && user.timeGoal || 30} minutes</span>
                                        </div>
                                        <div className='flex flex-col '>
                                            <span className='text-text text-lg lg:text-xl font-bold'>Lesson Goal</span>
                                            <span className='text-accent text-base lg:text-lg font-medium'>{Math.floor(lessonsComplete || 0)}/{!loading && user.lessonGoal || 7} lessons</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className='lg:basis-1/3 grow w-full xl:aspect-square bg-background-pop rounded-3xl cursor-pointer hover:bg-background-pop/80 transition-colors group relative overflow-hidden h-fit max-h-72 lg:max-h-none min-h-[16rem] lg:min-h-[18rem]'
                                onClick={() => setShowAwardsModal(true)}
                            >
                                <div className='text-xl pr-5 pl-7 py-3 font-medium text-text h-fit border-b-[3px] border-border flex items-center justify-between'>
                                    <h2 >Awards</h2>
                                    <Arrow className='mt-2 h-4 w-4 group-hover:translate-x-1 transition-transform' />
                                </div>
                                <div className='px-6 py-0 lg:py-5 flex flex-col gap-2 flex-grow items-center min-h-fit  overflow-y-auto no-scrollbar'>
                                    {user?.awards && user.awards.length > 0 ? (
                                        <div className="grid grid-cols-2 gap-2 w-full h-full">
                                            {[...user.awards].reverse().slice(0, 4).map((userAward, index) => {
                                                const configAward = AWARDS.find(a => a.id === userAward.id);
                                                const icon = configAward ? configAward.icon : Award;

                                                return (
                                                    <div key={index} className="flex flex-col items-center justify-center p-2 bg-background/30 rounded-xl aspect-square">
                                                        <img
                                                            src={icon === 'default' ? Award : icon}
                                                            alt={userAward.title}
                                                            className='w-2/3 h-2/3 object-contain mb-1 select-none'
                                                            draggable={false}
                                                        />
                                                        <span className='text-text text-xs font-bold text-center line-clamp-1'>{userAward.title}</span>
                                                    </div>
                                                );
                                            })}
                                            {user.awards.length > 4 && (
                                                <div className="absolute bottom-4 right-4 bg-primary text-white text-xs px-3 py-1 rounded-full shadow-md font-bold z-10">
                                                    +{user.awards.length - 4}
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="flex flex-col items-center justify-center flex-grow opacity-70 group-hover:opacity-100 transition-opacity py-4">
                                            <div className="w-36 h-36 bg-border/30 rounded-full flex items-center justify-center mb-4 shrink-0">
                                                <img src={Award} alt="No Awards" className='w-full h-full aspect-square _noDrag grayscale opacity-50' />
                                            </div>
                                            <span className='text-text text-lg font-bold'>No awards yet</span>
                                            <span className='text-text-light text-xs text-center mt-1 px-4'>Complete lessons to earn badges!</span>
                                        </div>
                                    )}
                                    {/* Gradient Fade Overlay */}
                                    <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-pop to-transparent pointer-events-none" />
                                </div>
                            </div>
                        </div>

                        {/* <div className='h-64 select-none flex flex-col lg:flex-row gap-4 w-full max-w-[900px]'>
                        <div className='w-full bg-[#23222d] grow h-min rounded-3xl'>
                            <div className=' text-xl pr-5 pl-7 py-3 font-medium text-white h-fit border-b-[3px] border-border flex items-center justify-between'>
                                <h2 >Daily Productivity Report</h2>
                                <Arrow className='mt-2 h-4 w-4' />
                            </div>
                            <div className='px-6 py-5 flex flex-row items-center min-h-fit gap-0'>
                                <div className='grow max-h-48 h-48'>
                                    <SkillChart data={statsHistory} />
                                </div>
                                <div className='flex flex-col justify-center gap-1 mb-1'>
                                <span className='text-white text-lg font-bold'>Stats</span>
                                <div className='flex flex-row items-center gap-2 w-max'>
                                    <div className='w-9 h-9 rounded-full bg-border flex items-center justify-center'>
                                        <SkillArrow w="23" h="23" colorStart="color-mix(in srgb, white 50%, var(--primary))" colorEnd="var(--primary)" id="1" />
                                    </div>
                                    <div className='flex flex-col font-bold mb-2'>
                                        <span className='text-white text-base font-bold'>Time Progress</span>
                                        <span className=' text-[0.7rem] leading-[1] text-primary'>+5%</span>
                                    </div>
                                </div>
                                <div className='flex flex-row items-center gap-2 w-max'>
                                    <div className='w-9 h-9 rounded-full bg-border flex items-center justify-center'>
                                        <SkillArrow w="23" h="23" colorStart="color-mix(in srgb, white 50%, var(--accent))" colorEnd="var(--accent)" id="2" />
                                    </div>
                                    <div className='flex flex-col font-bold mb-2'>
                                        <span className='text-white text-base font-bold'>Lesson Progress</span>
                                        <span className=' text-[0.7rem] leading-[1] text-accent'>+13%</span>
                                    </div>
                                </div>
                                <div className='flex flex-row items-center gap-2 w-max'>
                                    <div className='w-9 h-9 rounded-full bg-border flex items-center justify-center'>
                                        <SkillArrow w="23" h="23" colorStart="color-mix(in srgb, white 50%, var(--accent))" colorEnd="var(--accent)" id="3" />
                                    </div>
                                    <div className='flex flex-col font-bold mb-2'>
                                        <span className='text-white text-base font-bold'>Accuracy</span>
                                        <span className='text-[0.7rem] leading-[1] text-accent'>+8%</span>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div> */}
                    </>)}
            </div>
            <AwardsModal
                isOpen={showAwardsModal}
                onClose={() => setShowAwardsModal(false)}
                userAwards={user?.awards}
            />
        </div >
    );
}

export default Summary;